import { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import PaymentsHeader from 'src/components/Payments/Header';
import PaymentConfirmButton from 'src/components/Payments/PaymentConfirmButton';
import { PG_ERROR_CODE } from 'src/types/Payments';
import { ButtonWrapper, Container, Description, ErrorCode, ImgFailed, RootStyle, Wrapper } from './style';
interface PaymentsFailureProps {
  errorCode?: string;
}
const PaymentsFailure: FC<PaymentsFailureProps> = ({
  errorCode
}) => {
  const {
    t
  } = useTranslation();
  const errorMessage = useMemo(() => {
    switch (errorCode) {
      case PG_ERROR_CODE.PAY_PROCESS_CANCELED:
        return 'pg_error_cancel';
      case PG_ERROR_CODE.ERROR:
      case PG_ERROR_CODE.IMPLEMENTATION_ERROR:
      case PG_ERROR_CODE.COMMON_ERROR:
      case PG_ERROR_CODE.NETWORK_ERROR:
      default:
        return 'pg_error_common';
    }
  }, [errorCode]);
  return <RootStyle data-sentry-element="RootStyle" data-sentry-component="PaymentsFailure" data-sentry-source-file="index.tsx">
      <PaymentsHeader title='pg_purchase_fail' data-sentry-element="PaymentsHeader" data-sentry-source-file="index.tsx" />
      <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <Wrapper data-sentry-element="Wrapper" data-sentry-source-file="index.tsx">
          <ImgFailed src='/images/icons/imgFailed.png' alt='failed' data-sentry-element="ImgFailed" data-sentry-source-file="index.tsx" />
          <ErrorCode data-sentry-element="ErrorCode" data-sentry-source-file="index.tsx">{t('pg_purchase_fail')}</ErrorCode>
          <Description data-sentry-element="Description" data-sentry-source-file="index.tsx">{t(errorMessage)}</Description>
        </Wrapper>
        <ButtonWrapper data-sentry-element="ButtonWrapper" data-sentry-source-file="index.tsx">
          <PaymentConfirmButton data-sentry-element="PaymentConfirmButton" data-sentry-source-file="index.tsx">{t('COMMON__OK')}</PaymentConfirmButton>
        </ButtonWrapper>
      </Container>
    </RootStyle>;
};
export default PaymentsFailure;
export type { PaymentsFailureProps };